import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react'
import { Fragment, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import useInput from '../../hooks/useInput'
import { COMPLETE_INPUT } from '../../redux/actions'

interface Props {
  label: string
  inputName: string
  defaultValue?: string
  options?: any[]
  placeholder?: string
  storeForm: string
  setSelected: (param: string) => {}
  inputsPosition: 'stacked' | 'fixed' | 'floating' | undefined
  disabled?: boolean
  hidden?: boolean
}

const SelectForm = ({
  label,
  inputName,
  defaultValue,
  placeholder,
  options,
  storeForm,
  setSelected,
  inputsPosition,
  disabled,
  hidden
}: Props) => {
  const { input, reduxInput, error, itemRef, setInput, handleInput, handleError, validity } = useInput(
    inputName,
    storeForm,
    true
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (defaultValue) {
      setInput(defaultValue)
      dispatch({
        type: COMPLETE_INPUT,
        payload: { name: inputName, value: defaultValue, storeForm }
      })
    }
  }, [])

  useEffect(() => {
    if (validity) {
      dispatch({
        type: COMPLETE_INPUT,
        payload: { name: inputName, value: input, storeForm }
      })
      setSelected?.(input)
    } /* else dispatch({ type: COMPLETE_INPUT, payload: { name: inputName, value: '', storeForm } }); */
  }, [validity, input])

  const optInterface = {
    cssClass: 'select-options'
  }

  useEffect(() => {
    if (location.href.includes('prospecto')) setInput('')
  }, [location.href])

  return (
    <>
      <IonItem hidden={hidden} disabled={disabled} shape="round" ref={itemRef}>
        <IonLabel position={defaultValue ? 'stacked' : inputsPosition}>{label}</IonLabel>
        <IonSelect
          interface="popover"
          interfaceOptions={optInterface}
          name={inputName}
          placeholder={placeholder}
          value={input || reduxInput}
          onIonChange={handleInput}
          onIonBlur={handleError}
        >
          {options?.map((option, index) => (
            <Fragment key={uuidv4()}>
              {Boolean(index) && <hr key={uuidv4()} className="divider-select" />}
              {option && (
                <IonSelectOption key={uuidv4()} value={option.value}>
                  {option.label}
                </IonSelectOption>
              )}
            </Fragment>
          ))}
        </IonSelect>
      </IonItem>
      {!disabled && <span className="input-error">{error}</span>}
    </>
  )
}

export default SelectForm
